import Vue from 'vue'
import Vuex from 'vuex'
import entry from './modules/entry'
import guide from './modules/guide'
import entryguide from './modules/entryguide'
import CurrentUser from './modules/CurrentUser'
import user from './modules/user'
import edytowane from './modules/edytowane'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    entry,
    guide,
    entryguide,
    CurrentUser,
    user,
    edytowane
  },
  jwt: localStorage.getItem('token')
})